type PreviewStatus = "generating" | "success";

export const getIsValidPreviewUrl = (previewUrl: string) => {
  const [previewPath = ""] = previewUrl.split(/[?#]/);

  return !previewPath.toLowerCase().endsWith(".glb");
};

// The preview image is rendered server-side during file post-processing and arrives
// via the session object subscription. Until a valid preview URL is present we show
// the loading state — there is no client-side rendering.
export const getPreviewStatus = (
  previewUrl: string | null | undefined,
): PreviewStatus =>
  previewUrl && getIsValidPreviewUrl(previewUrl) ? "success" : "generating";
